"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
// eslint-disable-next-line complexity
function compileChoiceStyleString(choice = {}) {
    const { option: { alignItems, disabledColor, fontSize, fontWeight, gap, height, marginInlineEnd, marginTop, control: { border, position = 'left', colors: { bg, inactiveInternalBg, disabled } = {}, multiChoice: { borderRadius } = {}, singleChoice: { checkedSizeModifier, internalWidth } = {}, width } = {}, checkmark: { color, left, longSideWidth, shortSideWidth, top, weight } = {}, padding: { inlineStart, left: paddingLeft, top: paddingTop } = {} } = {} } = choice;
    return `{
        ${alignItems ? `--choice-option-align-items: ${alignItems};` : ''}
        ${bg ? `--choice-option-control-bg-color: ${bg};` : ''}
        ${border ? `--view-default-control-border: ${border};` : ''}
        ${borderRadius ? `--multi-choice-option-control-border-radius: ${borderRadius};` : ''}
        ${disabled ? `--choice-option-control-disabled-color: ${disabled};` : ''}
        ${disabledColor ? `--choice-option-label-disabled-color: ${disabledColor};` : ''}
        ${fontSize ? `--choice-option-label-font-size: ${fontSize};` : ''}
        ${Number.isInteger(fontWeight) ? `--choice-option-label-font-weight: ${fontWeight};` : ''}
        ${gap ? `--choice-option-gap: ${gap};` : ''}
        ${height ? `--choice-option-height: ${height};` : ''}
        ${inactiveInternalBg ? `--choice-option-unchecked-bg: ${inactiveInternalBg};` : ''}
        ${internalWidth ? `--radiobox-size-m-after-size: ${internalWidth};` : ''}
        ${isNaN(Number(checkedSizeModifier)) ? '' : `--choice-option-checked-transform: scale(${checkedSizeModifier});`}
        ${color ? `--choice-option-checkmark-color: ${color};` : ''}
        ${left ? `--choice-option-checkmark-left: ${left};` : ''}
        ${longSideWidth ? `--choice-option-checkmark-long-side-width: ${longSideWidth};` : ''}
        ${marginInlineEnd ? `--choice-option-margin-inline-end: ${marginInlineEnd};` : ''}
        ${marginTop ? `--choice-option-margin-top: ${marginTop};` : ''}
        ${inlineStart ? `--choice-option-padding-inline-start: ${inlineStart};` : ''}
        ${paddingLeft ? `--choice-option-padding-left: ${paddingLeft};` : ''}
        ${paddingTop ? `--choice-option-padding-top: ${paddingTop};` : ''}
        ${position === 'right' ? `--choice-option-flex-direction: row-reverse;` : ''}
        ${shortSideWidth ? `--choice-option-checkmark-short-side-width: ${shortSideWidth};` : ''}
        ${top ? `--choice-option-checkmark-top: ${top};` : ''}
        ${weight ? `--choice-option-checkmark-weight: ${weight};` : ''}
        ${width ? `--choice-option-control-width: ${width};` : ''}
    }`;
}
function brandingChoiceStyles(branding = {}) {
    const { choice, darkTheme } = branding;
    const lightThemeString = compileChoiceStyleString(choice);
    if (darkTheme === null || darkTheme === void 0 ? void 0 : darkTheme.choice) {
        const darkThemeString = compileChoiceStyleString(Object.assign(Object.assign({}, choice), darkTheme.choice));
        return (0, react_1.css) `
            :root ${lightThemeString}

            .pythia-surveys-root[data-theme='light'] ${lightThemeString}
            .pythia-surveys-root[data-theme='dark'] ${darkThemeString}
        `;
    }
    return (0, react_1.css) `
        :root ${lightThemeString}

        .pythia-surveys-root[data-theme='light'] ${lightThemeString}
    `;
}
exports.default = brandingChoiceStyles;
